// extracted by mini-css-extract-plugin
export default {"button":"exportButton__button-HKrk4","icon":"exportButton__icon-xYV02","tooltipHeader":"exportButton__tooltipHeader-ZgkbC","tooltipParagraph":"exportButton__tooltipParagraph-RUqfy"};